import { useState } from 'react'
import { Button } from '../components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card'
import { toast } from 'sonner'

export default function InitialSetup() {
  const [loading, setLoading] = useState(false)

  const createInitialUsers = async () => {
    setLoading(true)
    try {
      console.log('Starte Benutzer-Erstellung...')

      // Admin-Benutzer erstellen
      console.log('Erstelle Admin-Benutzer...')
      const adminResponse = await fetch('/api/setup/init', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (!adminResponse.ok) {
        const error = await adminResponse.json()
        throw new Error(error.error || 'Fehler beim Erstellen der Benutzer')
      }

      const result = await adminResponse.json()
      console.log('Benutzer erstellt:', result)

      toast.success('Benutzer erfolgreich erstellt! Sie können sich jetzt einloggen.')
    } catch (error) {
      console.error('Detaillierter Fehler beim Erstellen der Benutzer:', {
        message: error.message,
        stack: error.stack,
        error
      })
      toast.error(`Fehler beim Erstellen der Benutzer: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <Card className="w-[400px]">
        <CardHeader>
          <CardTitle className="text-2xl text-center">
            System Einrichtung
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-gray-600">
            Klicken Sie auf den Button unten, um die initialen Benutzer zu erstellen:
            <br /><br />
            Admin: admin@example.com / admin123
            <br />
            Vertrieb: sales@example.com / sales123
          </p>
          <Button
            className="w-full"
            onClick={createInitialUsers}
            disabled={loading}
          >
            {loading ? 'Lädt...' : 'Benutzer erstellen'}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
} 